import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

export default function OrderSuccess({ onContinue }) {
  return (
    <div className="max-w-md mx-auto text-center py-20 animate-fade-in" data-testid="order-success">
      <CheckCircle className="w-16 h-16 mx-auto mb-4" style={{ color: "var(--mp-text-strong)" }} />
      <h2
        className="text-2xl font-medium mb-2"
        style={{ fontFamily: "'Cormorant Garamond', serif", color: "var(--mp-text)" }}
      >
        Order Placed Successfully!
      </h2>
      <p
        className="text-sm mb-2"
        style={{ fontFamily: "'Manrope', sans-serif", color: "var(--mp-muted)" }}
      >
        Your order has been received. We will confirm availability and contact you on WhatsApp
        shortly.
      </p>
      <p
        className="text-xs mb-6 pastel-yellow inline-block px-3 py-1 rounded-sm"
        style={{ fontFamily: "'Manrope', sans-serif", color: "var(--mp-copper-deep)" }}
      >
        GST 5% plus transport (local lorry Rs. 100/parcel, bus/travels Rs. 150/parcel) added at billing
      </p>
      <div className="flex gap-3 justify-center flex-wrap">
        <Button
          onClick={onContinue}
          className="text-white text-sm px-6 py-3 rounded-sm"
          style={{ backgroundColor: "var(--mp-solid)" }}
        >
          Continue Shopping
        </Button>
        <Link to="/dashboard">
          <Button
            variant="outline"
            className="text-sm px-6 py-3 rounded-sm"
            style={{ borderColor: "var(--mp-solid)", color: "var(--mp-text-strong)" }}
          >
            View My Orders
          </Button>
        </Link>
      </div>
    </div>
  );
}
